import React from 'react';
import Icon from './Icon';

const ChevronUpIcon = ({ size, className, ...props }) => {
  return (
    <Icon size={size} className={className} {...props}>
      <path 
        d="M18 15L12 9L6 15" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default ChevronUpIcon;
